import { render, staticRenderFns } from "./PartnerSponsors.vue?vue&type=template&id=3c26dc72&scoped=true"
import script from "./PartnerSponsors.vue?vue&type=script&lang=js"
export * from "./PartnerSponsors.vue?vue&type=script&lang=js"
import style0 from "./PartnerSponsors.vue?vue&type=style&index=0&id=3c26dc72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c26dc72",
  null
  
)

export default component.exports